// LICENSE_CODE ZON
/*jslint browser:true, es6:true, node:true, react:true*/
import React, {forwardRef, useState} from 'react';

import hopt from 'hola_opt';
import etask from 'zetask';
import {get} from 'zutil';
import {i_user_info} from 'hola_app_context';
import {Input} from '../../../../../hola/pub/lib/input';
import plus_util from '/www/hola/pub/plus_util.js';
import {get_payment_opts} from '../helpers/helpers';

import styles from './email_field.module.less';

type t_email_field_props = {
		user?: i_user_info | null;
}

export type t_email_field_ref = {
		get_email: () => string | false;
};

const email_validator = email=>etask(function*(){
    if (hopt.www_hola.no_email_validation_on_blur)
        return '';
    const err = email && plus_util.validate_email_syntax(email);
    return err ? err : yield plus_util.validate_email_domain(email);
});

// Email field for usage inside paymend API
// Provides ref for getting last email value before submiting inside callback
// without recreating callback on email field change

export const Email_field = forwardRef<t_email_field_ref, t_email_field_props>(
({user}, ref)=>{
		const [email, set_email]
			= useState(user ? get(user, 'emails.0.value') : '');
    const [email_err, set_email_err] = useState('');
    if ('current' in ref)
    {
        ref.current = {
            get_email: ()=>{
                const email_result = get_payment_opts(user, email).email;
                if (!email)
                {
                    set_email_err(plus_util.empty_email_err);
                    return '';
                }
                else if (plus_util.validate_email_syntax(email))
                {
                    set_email_err(plus_util.validate_email_syntax(email));
                    return '';
                }
                return email_result;
            }
        };
    }
    if (user)
        return null;
    return (
      <Input
        cl={styles.email_field}
        on_change_validation={false}
        name="email" auto_complete="email" value={email}
        validator={email_validator} inputmode="email"
        placeholder="name@example.com" label="Email"
        on_validation={set_email_err} error={email_err}
        on_change={set_email}/>
    );
});
